import useSWR from 'swr';
import getMapaByID from '../services/mapa';

export default function useMapa(id) {
  return useSWR(id ? ['mapa', id] : null, () => getMapaByID(id));
}
